import React, { useState, useEffect } from "react";
import { FaReply } from "react-icons/fa";
import DeleteModal from "./Assets/DeleteModal";
import { toast } from "react-toastify";

const EnquiryList = () => {
  const [enquiries, setEnquiries] = useState([]);
  useEffect(() => {
      fetchData();
    }, []);
  
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        console.log("Using token:", token);
        const response = await fetch("https://hind-eng.serverscripts.in/api/v1/contactus/view", {
          method: "GET",
           headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
            },
        });
        console.log("Fetch response status:", response);
  
        const result = await response.json();
        if (result.success) setEnquiries(result.data);
        else toast.error(result.message || "Failed to fetch Contact Details");
      } catch (error) {
        console.error("Fetch error:", error);
        toast.error("Failed to fetch Contact Details");
      }
    };


  return (
    <div className="p-5 bg-gray-50 min-h-screen">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-semibold text-gray-700">
          Enquiry Details
        </h2>
      </div>

      <div className="overflow-x-auto bg-white shadow rounded-lg">
        <table className="min-w-full border border-gray-200">
          <thead className="bg-blue-600 text-white">
            <tr>
              <th className="py-2 px-4 text-left">#</th>
              <th className="py-2 px-4 text-left">Name</th>
              <th className="py-2 px-4 text-left">Email</th>
              <th className="py-2 px-4 text-center">Message</th>
              <th className="py-2 px-4 text-center">Created At</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {enquiries.length > 0 ? (
              enquiries.map((enquiry, index) => (
            
              <tr
                key={enquiry.id}
                className="hover:bg-gray-50 transition duration-150"
              >
                <td className="py-3 px-4">{index + 1}</td>
                <td className="py-3 px-4 font-medium text-gray-800">
                  {enquiry.name}
                </td>
                <td className="py-3 px-4 text-gray-700">{enquiry.email}</td>
                <td className="py-3 px-4 text-gray-600 text-sm max-w-xs truncate text-center">
                  {enquiry.message}
                </td>
                <td className="py-3 px-4 text-center text-gray-700">
                  {enquiry.created_at}
                </td>
                
              </tr>
            ))
              ) : (
                        <tr>
                          <td colSpan={6} className="p-2 text-center">
                            No enquiries found
                          </td>
                        </tr>
                      )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EnquiryList;
